module.exports = __webpack_public_path__ + "static/media/judge-prof-bo-an.83eb6931.jpg";